import React from 'react';
import { Link } from 'react-router-dom';
import { useSpring, animated } from 'react-spring';

const Main = ({children, className}) => {
  return (
    <div className={`h-3rem w-full surface-800 ${className} relative`}>
      <div className="flex justify-content-between align-items-center align-items-stretch h-full">
        { children }
      </div>
    </div>
  )
}

const Dropdown = ({children, filter}) => {
  const _filterDraw = useSpring({
    marginTop: filter ? 0 : 0
  })
  
  return (
    <animated.div style={_filterDraw} className="surface-900 ">
      { Boolean(filter) && 
      <div className="h-auto">
        { Array.isArray(children) ? children[filter - 1] : children }
      </div>} 
    </animated.div>
  )
}


const NavLink = ({children, className, isActive, to}) => {
  let cssClass = isActive ? 'bg-white-alpha-50': '';
  return (
    <Link to ={ to } className={`p-2 ${className} ${ cssClass}`}> {children} </Link>
  )
}

const Header = ({ children }) => ( <header> { children } </header> );
const Upper = ({ children }) =>  ( <section className="text-white relative"> {children} </section>)
const Lower = ({ children }) => (<section className="lower-header pl-3 pr-3"> {children} </section>)
const Filters = ({ children }) =>  ( <div className="flex align-items-center justify-content-center">{ children }</div>)
const Search = ({ children }) =>  ( <div className="flex gap-3">{ children }</div> )
const SubNav = ({ children }) => ( <div className="overflow-y-auto max-h-8rem p-2">{ children }</div>)


Header.Upper = Upper
Header.Lower = Lower
Header.Main = Main
Header.Filters = Filters
Header.Search = Search
Header.SubNav = SubNav
Header.NavLink = NavLink
Header.Dropdown = Dropdown


export default Header; 